import { Resources } from '../../utils/resources/resources';
import { BaseContext } from '../../utils/basecontext';

export interface UIComponentCSSStyle 
{
    getWrapperCSSStyle(): object;
}

export class UIComponentCSSStyleImpl implements UIComponentCSSStyle
{
    constructor(private context: BaseContext)
    {
      
    }

    protected getContext(): BaseContext
    {
        return this.context;
    }

    protected getResources(): Resources
    {
        return this.context.getResources();
    }
    
    getWrapperCSSStyle(): object {
        return {
            height: "100%",
            width: "100%",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss.tsx